import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

export const FAQ = ({ onContactClick }) => {
  const faqCategories = [
    {
      title: 'Wirtschaftlichkeit',
      questions: [
        {
          q: 'Wie schnell amortisiert sich ein BESS im Krankenhaus?',
          a: 'Die Amortisationszeit liegt typischerweise zwischen 5 und 8 Jahren, abhängig von Ihrem Lastprofil, Stromtarif und der Speichergröße. Bei günstigen Rahmenbedingungen (hohe Lastspitzen, bestehende PV-Anlage) sind auch kürzere Zeiträume möglich. Wir erstellen Ihnen eine individuelle Wirtschaftlichkeitsrechnung basierend auf Ihren Verbrauchsdaten.',
        },
        {
          q: 'Welche Einsparungen sind realistisch?',
          a: 'In der Praxis sehen wir Gesamteinsparungen von 15-25% der Stromkosten. Diese setzen sich zusammen aus Peak Shaving (8-15%), Eigenverbrauchsoptimierung bei PV (variabel), Arbitrage (3-8%) und ggf. Einnahmen aus Regelenergie. Die genauen Werte hängen von Ihrem individuellen Profil ab.',
        },
        {
          q: 'Gibt es Fördermittel für Batteriespeicher?',
          a: 'Ja, es gibt verschiedene Förderprogramme auf Bundes- und Landesebene. Dazu gehören KfW-Förderkredite, Landesprogramme zur Energieeffizienz im Gesundheitswesen und kommunale Fördertöpfe. Wir beraten Sie gerne zu den aktuell verfügbaren Optionen und unterstützen bei der Antragstellung.',
        },
        {
          q: 'Welche Finanzierungsmodelle gibt es?',
          a: 'Neben der Direktinvestition bieten wir Leasing, Mietkauf und Contracting-Modelle an. Beim Contracting übernehmen wir die Investition, Sie profitieren sofort von garantierten Einsparungen ohne eigenen Kapitaleinsatz. Wir beraten Sie zum für Sie passenden Modell.',
        },
      ],
    },
    {
      title: 'Technik & Sicherheit',
      questions: [
        {
          q: 'Wie sicher ist ein Batteriespeicher im Krankenhaus?',
          a: 'Sehr sicher. Wir setzen auf Lithium-Eisenphosphat (LFP) Technologie, die als sicherste Lithium-Ionen-Variante gilt. Zusätzlich sind unsere Systeme mit mehrfach redundanten Sicherheitssystemen ausgestattet: Batteriemanagementsystem, Brandfrüherkennung, automatische Löschanlage und elektrische Schutzeinrichtungen. Alle Systeme sind TÜV-zertifiziert.',
        },
        {
          q: 'Wie lange hält ein Batteriespeicher?',
          a: 'Unsere LFP-Systeme sind für mindestens 6.000 Vollzyklen ausgelegt, was einer Lebensdauer von 15-20 Jahren entspricht. Wir geben eine Kapazitätsgarantie von 10 Jahren. Nach dieser Zeit ist die Batterie nicht defekt, sondern hat noch ca. 80% ihrer ursprünglichen Kapazität.',
        },
        {
          q: 'Kann das BESS auch als Notstromversorgung dienen?',
          a: 'Ja, das ist einer der wichtigsten Anwendungsfälle. Das BESS übernimmt bei Netzausfall binnen Millisekunden die Versorgung und überbrückt die Zeit, bis das Diesel-Notstromaggregat voll hochgefahren ist. So entsteht eine lückenlose, unterbrechungsfreie Stromversorgung für kritische Systeme.',
        },
        {
          q: 'Wie viel Platz benötigt ein BESS?',
          a: 'Das hängt von der Kapazität ab. Ein 1-MWh-System benötigt typischerweise die Grundfläche eines 20-Fuß-Containers (ca. 15 m²). Bei Platzmangel ist auch eine Innenaufstellung in modularen Schränken möglich. Wir planen die Aufstellung individuell nach Ihren räumlichen Gegebenheiten.',
        },
      ],
    },
    {
      title: 'Projektablauf',
      questions: [
        {
          q: 'Wie lange dauert die Installation eines BESS?',
          a: 'Von der Beauftragung bis zur Inbetriebnahme vergehen typischerweise 4-6 Monate. Die reine Bauphase vor Ort dauert 4-8 Wochen, abhängig von der Komplexität. Der Krankenhausbetrieb wird dabei minimal beeinträchtigt.',
        },
        {
          q: 'Welche Daten brauchen Sie für eine erste Einschätzung?',
          a: 'Für eine erste Potenzialanalyse benötigen wir Ihre Lastgangdaten (15-Minuten-Werte) der letzten 12 Monate sowie aktuelle Stromrechnungen. Diese Daten erhalten Sie von Ihrem Netzbetreiber. Falls Sie eine PV-Anlage haben, sind Erzeugungsdaten hilfreich. Wir unterstützen Sie bei der Beschaffung.',
        },
        {
          q: 'Wer ist für Betrieb und Wartung zuständig?',
          a: 'Das System läuft vollautomatisch und erfordert keine tägliche Betreuung. Wir bieten 24/7 Fernüberwachung und jährliche Wartung an. Bei Störungen sind wir über unsere Hotline erreichbar und können viele Probleme per Fernzugriff lösen. Vor Ort eingreifen müssen wir nur selten.',
        },
        {
          q: 'Welche Genehmigungen sind erforderlich?',
          a: 'Das hängt von der Aufstellsituation ab. Bei Außenaufstellung kann eine Baugenehmigung erforderlich sein. In jedem Fall erfolgt eine Anmeldung beim Netzbetreiber. Wir übernehmen alle notwendigen Genehmigungsverfahren für Sie.',
        },
      ],
    },
    {
      title: 'Integration & Betrieb',
      questions: [
        {
          q: 'Lässt sich ein BESS mit einer bestehenden PV-Anlage kombinieren?',
          a: 'Ja, die Kombination mit PV ist einer der wirtschaftlichsten Anwendungsfälle. Das BESS speichert überschüssigen Solarstrom und ermöglicht Eigenverbrauchsquoten von bis zu 90%. Die Integration erfolgt in der Regel einfach über den bestehenden Netzanschlusspunkt.',
        },
        {
          q: 'Kann das System in die Gebäudeleittechnik integriert werden?',
          a: 'Ja, wir bieten Schnittstellen zu allen gängigen GLT-Systemen. So können Sie Betriebsdaten einsehen und das BESS in Ihre bestehende Energiemanagement-Strategie einbinden. Auch die Anbindung an übergeordnete Visualisierungssysteme ist möglich.',
        },
        {
          q: 'Funktioniert das System auch bei Netzausfall?',
          a: 'Ja, genau dafür ist es konzipiert. Das BESS erkennt Netzausfälle innerhalb von Millisekunden und übernimmt die Versorgung kritischer Lasten. Die Autonomiezeit hängt von der Speicherkapazität und dem Verbrauch ab, typisch sind 15-30 Minuten – genug Zeit, um das Notstromaggregat hochzufahren.',
        },
        {
          q: 'Wie wird das System gesteuert?',
          a: 'Die intelligente Steuerung erfolgt vollautomatisch durch unser Energiemanagementsystem. Dieses analysiert kontinuierlich Lastprofile, Strompreise und Prognosen, um den wirtschaftlich optimalen Einsatz zu gewährleisten. Sie können Parameter anpassen und Betriebsdaten über ein Web-Dashboard einsehen.',
        },
      ],
    },
  ];

  return (
    <main className="pt-16 lg:pt-20">
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-br from-slate-50 to-white" data-testid="faq-hero">
        <div className="container-main">
          <div className="max-w-3xl">
            <span className="text-[#10B981] font-medium text-sm uppercase tracking-wide">FAQ</span>
            <h1 className="heading-xl text-[#0F172A] mt-2 mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Häufig gestellte Fragen
            </h1>
            <p className="text-lg text-slate-600 mb-8">
              Hier finden Sie Antworten auf die wichtigsten Fragen rund um Batteriespeicher für Krankenhäuser. 
              Falls Ihre Frage nicht dabei ist, kontaktieren Sie uns gerne.
            </p>
            <Button 
              onClick={onContactClick}
              className="btn-primary inline-flex items-center gap-2"
              data-testid="faq-cta-btn"
            >
              Individuelle Frage stellen
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* FAQ Sections */}
      <section className="section-padding bg-white" data-testid="faq-sections">
        <div className="container-main">
          <div className="max-w-4xl mx-auto">
            {faqCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-12" data-testid={`faq-category-${categoryIndex + 1}`}>
                <h2 className="text-2xl font-semibold text-[#0F172A] mb-6 pb-4 border-b border-slate-200" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {category.title}
                </h2>
                <Accordion type="single" collapsible className="space-y-4">
                  {category.questions.map((item, index) => (
                    <AccordionItem 
                      key={index} 
                      value={`${categoryIndex}-${index}`}
                      className="bg-slate-50 rounded-lg px-6 border border-slate-100"
                      data-testid={`faq-item-${categoryIndex}-${index}`}
                    >
                      <AccordionTrigger className="text-left font-medium text-[#0F172A] hover:no-underline py-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                        {item.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-slate-600 pb-4 leading-relaxed">
                        {item.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="section-padding bg-slate-50" data-testid="still-questions">
        <div className="container-main">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="heading-lg text-[#0F172A] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Ihre Frage war nicht dabei?
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              Jedes Krankenhaus ist einzigartig. Kontaktieren Sie uns für eine individuelle Beratung 
              zu Ihrer spezifischen Situation.
            </p>
            <Button 
              onClick={onContactClick}
              className="btn-primary inline-flex items-center gap-2"
              data-testid="faq-contact-btn"
            >
              Persönliche Beratung anfragen
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#0F172A] text-white" data-testid="faq-final-cta">
        <div className="container-main text-center">
          <h2 className="heading-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Bereit für den nächsten Schritt?
          </h2>
          <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
            Lassen Sie uns Ihr individuelles Einsparpotenzial ermitteln – kostenlos und unverbindlich.
          </p>
          <Button 
            onClick={onContactClick}
            className="bg-[#10B981] hover:bg-emerald-600 text-white px-8 py-4 rounded-md font-medium inline-flex items-center gap-2"
            data-testid="faq-cta-final"
          >
            Kostenlose Erstberatung
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </section>
    </main>
  );
};
